import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { OrganizationService } from 'src/app/private/services/organization.services';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-create-department',
  imports: [SharedModule],
  templateUrl: './create-department.component.html',
  styleUrls: ['./create-department.component.scss']
})
export class CreateDepartmentComponent {

  @Output() close = new EventEmitter<void>();
  @Input() orgId: string = ''; // Organization ID passed from the parent component
  isLoading: boolean = false; // Loading state for the form submission
  @Input() departmentDataToEdit: any = null; // To hold the department data to be edited
  @Input() type = 'Create'; // Type of operation (create or edit)
  @Output() reload = new EventEmitter<void>(); // Event emitter to notify parent component for reloading data
  @Input() campuses: any[] = []; // List of campuses passed to the component
  @Input() users: any[] = []; // List of users passed to the component

  departmentForm: FormGroup;
  submitted = false;

  statusOptions = [
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' }
  ];

  ngOnInit() {
    if (this.type === 'Update' && this.departmentDataToEdit) {
      console.log(this.departmentDataToEdit);
      this.departmentForm.patchValue(this.departmentDataToEdit); // Populate the form with existing data
    }

    this.users = this.users?.map((user) => {
      return { label: user.fname + ' ' + user.lname, value: user.user_id };
    });

    console.log(this.users);

  }

  constructor(private fb: FormBuilder,
    private orgService: OrganizationService,
    private messageService: MessageService
  ) {
    this.departmentForm = this.fb.group({
      organization_id: [this.orgId], // Organization ID
      campus_id: [null, Validators.required],
      name: ['', Validators.required],
      code: ['', Validators.required],
      head_of_department: [ null],
      description: [''],
      contact_number: [''],
      email: ['', [Validators.email, Validators.required]],
      status: ['', Validators.required],
      is_public: [false]
    });
  }

  submitForm() {
    //this.submitted = true;

    if (this.departmentForm.invalid) {
      this.submitted = true;
      //this.departmentForm.markAllAsTouched();
      return;
    }

    const payload: any = this.departmentForm.value;
    payload.organization_id = this.orgId; // Set the organization ID

    this.isLoading = true;

    if (this.type === 'Update') {
      payload.dept_id = this.departmentDataToEdit.dept_id;
      this.orgService.updateDepartment(payload).subscribe(
        (response) => {
          this.isLoading = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Department updated successfully!' });
          this.reload.emit(); // Reload data
          this.handleCloseDialog();
        },
        (error) => {
          this.isLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update department!' });
        }
      );
    } else {
      this.orgService.createDepartment(payload).subscribe(
        (response) => {
          this.isLoading = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Department created successfully!' });
          this.reload.emit();
          this.handleCloseDialog();
        },
        (error) => {
          this.isLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create department!' });
        }
      );
    }
  }

  handleCloseDialog() {
    this.close.emit();
  }

}
